module.exports = __webpack_public_path__ + "static/media/team-firelight.a2d2192b.png";